import React from "react";
import { withStyles, Grid, Typography } from "@material-ui/core";
import ChevronRight from "@material-ui/icons/ChevronRight";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import Search from "@material-ui/icons/Search";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import clsx from "clsx";
import styles from "./SupportContainer.styles";
import BlogService from "../../services/blog.service";
import BlogPost from "../../components/BlogPost";
import strings from "../../LocalizedStrings";

const parse = require("html-react-parser");

class BlogContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      posts: [],
      searchValue: "",
      searchMade: false,
    };
  }

  componentWillMount() {
    this.getPosts(this.props.language);
    window.scrollTo(0, 0);
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (this.props.language !== nextProps.language) {
      this.getPosts(nextProps.language);
    }
  }

  getPosts = (language: string) => {
    const { match, history } = this.props;
    const { params } = match;
    const blogService = new BlogService();
    blogService.getPosts(language).then((posts: any) => {
      console.log(posts);

      const allPosts: Array<any> = posts.items.map((post: any) => post);

      console.log("allPosts", allPosts);

      const supportPosts: Array<any> = allPosts
        .filter((post: any) => post.sys.contentType.sys.id === "support")
        .map((post: any) => {
          let iframe = null;
          if (post.fields.supportContent) {
            const blockQuotes = post.fields.supportContent.content.filter(
              (supportPost: any) => supportPost.nodeType === "blockquote"
            );
            console.log("blockQuotes", blockQuotes);
            blockQuotes.forEach((supportPost: any) => {
              if (supportPost.content[0].content[0].value.includes("iframe")) {
                iframe = supportPost.content[0].content[0].value;
              }
            });
          }
          return {
            title: post.fields.supportDocumentTitle,
            description: post.fields.supportContent,
            id: post.sys.id,
            category: post.fields.category,
            iframe,
            slug: post.fields.slug,
          };
        });
      console.log("supportPosts", supportPosts);
      if (params.slug) {
        blogService
          .getPostBySlug(params.slug, "support", language)
          .then((post: any) => {
            if (post.items.length > 0) {
              let iframe = null;
              if (post.items[0].fields.supportContent) {
                const blockQuotes = post.items[0].fields.supportContent.content.filter(
                  (supportPost: any) => supportPost.nodeType === "blockquote"
                );
                console.log("blockQuotes", blockQuotes);
                blockQuotes.forEach((supportPost: any) => {
                  if (
                    supportPost.content[0].content[0].value.includes("iframe")
                  ) {
                    iframe = supportPost.content[0].content[0].value;
                  }
                });
              }
              this.setState({
                selectedPost: {
                  title: post.items[0].fields.supportDocumentTitle,
                  description: post.items[0].fields.supportContent,
                  id: post.items[0].sys.id,
                  category: post.items[0].fields.category,
                  iframe,
                  slug: post.items[0].fields.slug,
                },
              });
            } else {
              history.replace("/");
            }
          });
      }

      this.setState({ posts: supportPosts });
    });
  };

  onBlogPostSelected(id: string) {
    this.props.history.push(`/${id}`);
  }

  getMobilePosts() {
    const { classes } = this.props;
    const { selectedPost } = this.state;
    let shownPost = null;
    const options = {
      renderNode: {
        [BLOCKS.EMBEDDED_ASSET]: (node: any) => {
          const {
            data: {
              target: { fields },
            },
          } = node;
          return `<img src="${fields.file.url}" height="${fields.file.details.image.height}" width="${fields.file.details.image.width}" alt="${fields.description}"/>`;
        },
      },
    };
    if (this.state.posts.length === 0) {
      return null;
    } else if (!selectedPost) {
      shownPost = this.state.posts[0];
    } else {
      shownPost = selectedPost;
    }
    return (
      <Grid className={classes.supportEntryContainer}>
        <h1>{shownPost.title}</h1>
        <div
          dangerouslySetInnerHTML={{
            __html: documentToHtmlString(shownPost.description, options),
          }}
        />
        {shownPost.iframe &&
          parse(`<div class='iframeContainer'>${shownPost.iframe}</div>`)}
      </Grid>
    );
  }

  getResultPosts = () => {
    const { searchResult, posts } = this.state;
    const { classes } = this.props;
    if (searchResult.length > 0) {
      return (
        <Grid className={classes.resultEntriesContainer}>
          <h1>Search Results:</h1>
          {searchResult.map((result: any) => {
            const retrievePost = posts.filter(
              (post: any) => post.slug === result.slug
            );
            return (
              <Grid
                className={classes.resultEntryContainer}
                onClick={() => this.selectPost(retrievePost[0])}
              >
                <p className={classes.resultTitle}>{result.title}</p>
                <p className={classes.resultCategory}>{result.category}</p>
              </Grid>
            );
          })}
        </Grid>
      );
    } else {
      return (
        <Grid className={classes.resultEntriesContainer}>
          <h1>No results</h1>
        </Grid>
      );
    }
  };

  toggleMenu = (category: any) => {
    const { selectedCategory } = this.state;
    if (selectedCategory === category) {
      this.setState({ selectedCategory: null });
    } else {
      this.setState({ selectedCategory: category });
    }
  };

  selectPost = (selectedPost: any) => {
    this.setState({ selectedPost });
    const { history } = this.props;
    history.replace(`/${selectedPost.slug}`);
    this.setState({
      searchValue: "",
      searchMade: false,
    });
  };

  handleChange = (event: any) => {
    const { target } = event;
    const { value } = target;
    this.setState({ searchValue: value });
  };

  handleKeyUp = (event: any) => {
    console.log("event.key", event.key);
    if (event.key === "Enter") {
      this.searchPost();
    }
  };

  searchPost = () => {
    const { language } = this.props;
    const { searchValue } = this.state;
    const blogService = new BlogService();
    blogService
      .searchPost(searchValue, "support", language)
      .then((posts: any) => {
        console.log("posts", posts);
        let searchResult = [];
        if (posts.items.length > 0) {
          searchResult = posts.items.map((post: any) => ({
            slug: post.fields.slug,
            title: post.fields.supportDocumentTitle,
            category: post.fields.category,
          }));
        }
        this.setState({ searchResult, searchMade: true });
      });
  };

  render() {
    const { classes } = this.props;
    const {
      posts,
      selectedCategory,
      searchValue,
      searchMade,
      selectedPost,
    } = this.state;
    let shownPost: any = null;
    if (!selectedPost) {
      shownPost = this.state.posts[0];
    } else {
      shownPost = selectedPost;
    }
    console.log("this.state", this.state);
    const categories = [...new Set(posts.map((post: any) => post.category))];
    console.log("categories", categories);
    return (
      <Grid
        className={classes.componentContainer}
        container
        sm={12}
        justify="center"
      >
        <Grid
          container
          item
          justify="flex-start"
          className={clsx(
            classes.mainContentContainer,
            classes.minHeightContainer
          )}
        >
          <div className={classes.searchContainer}>
            <input
              type="search"
              className={clsx(classes.searchInput, "search-input w-input")}
              name="query"
              placeholder="Search our knowledge base…"
              id="search"
              value={searchValue}
              onChange={this.handleChange}
              onKeyUp={this.handleKeyUp}
            />
            <Search onClick={this.searchPost} className={classes.searchIcon} />
          </div>
          <Grid container>
            <div className={classes.supportMenu}>
              {categories.map((category: any) => (
                <div
                  data-hover=""
                  data-delay="0"
                  className="support-accordion"
                  key={category}
                >
                  <div
                    className={
                      selectedCategory === category
                        ? clsx(
                            classes.selectedMenuItem,
                            "accordion-toggle w-dropdown-toggle"
                          )
                        : clsx(
                            classes.menuItem,
                            "accordion-toggle w-dropdown-toggle"
                          )
                    }
                    id={category}
                    aria-haspopup="menu"
                    aria-expanded="false"
                    role="button"
                    onClick={() => {
                      this.toggleMenu(category);
                    }}
                  >
                    <div>{category}</div>
                    {selectedCategory === category ? (
                      <KeyboardArrowDown className={classes.selectedMenuItem} />
                    ) : (
                      <ChevronRight />
                    )}
                  </div>
                  <nav
                    className={
                      selectedCategory === category
                        ? "dropdown-list w-dropdown-list w--open"
                        : "dropdown-list w-dropdown-list"
                    }
                    id={`w-dropdown-list-${category}`}
                  >
                    {posts
                      .filter((post: any) => post.category === category)
                      .map((post: any) => (
                        <a
                          href="#"
                          className={
                            shownPost.title === post.title
                              ? clsx(classes.selectedSubmenu, "w-dropdown-link")
                              : clsx(classes.submenu, "w-dropdown-link")
                          }
                          onClick={() => {
                            this.selectPost(post);
                          }}
                        >
                          {post.title}
                        </a>
                      ))}
                  </nav>
                </div>
              ))}
            </div>
            <div className={classes.supportContent}>
              {searchMade ? this.getResultPosts() : this.getMobilePosts()}
            </div>
          </Grid>
        </Grid>
        <div className={clsx(classes.mainContentContainer, classes.ctaBlock)}>
          <div
            data-w-id="572b11f6-c648-16c7-6b84-eb6d10a6892e"
            style={{
              transform:
                "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
              opacity: 1,
              transformStyle: "preserve-3d",
            }}
            className="cta-block"
          >
            <h3 id="w-node-eb6d10a68931-24aef9d9" className="paragraph cta">
              <span className="heading-4 cta">
                Quick and effortless implementation
              </span>
              {`
          Setup only takes a few days, we’ll help you choose the information needed and take care of the rest.`}
            </h3>
            <a
              href="http://athum.com/contact-form-sales.html"
              id="w-node-5c02fae33671-24aef9d9"
              data-w-id="2cc8109b-e5ec-2a1c-af04-5c02fae33671"
              className="button4 w-button"
            >
              Start Today
            </a>
          </div>
        </div>
      </Grid>
    );
  }
}

export default withStyles(styles)(BlogContainer);
